import { JetView } from 'webix-jet'; // Importing JetView for creating a view
import FilterCasinoReport from 'views/leagues/reports/casinoReport/filterCasinoReport'; // Importing filter component
import TableCasinoReport from 'views/leagues/reports/casinoReport/tableCasinoReport'; // Importing table component
import DetailsCasinoReport from 'views/leagues/reports/casinoReport/detailsCasinoReport'; // Importing details component
import RecordCasinoReport from 'views/leagues/reports/casinoReport/recordCasinoReport'; // Importing record component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the Casino Report View.
 * @extends JetView
 */
export default class CasinoReportView extends JetView {
    /**
     * Configures the layout of the Casino Report View.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const theme = this.app.config.theme; // Current theme configuration

        // Right section configuration with record and details components
        const right = {
            type: 'wide',
            minWidth: 200,
            rows: [RecordCasinoReport, DetailsCasinoReport],
        };

        // Toolbar configuration with pagination
        const toolbar = {
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager',
                    id: 'pagerA', // Unique identifier for the pager
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default data fetch size from config
                },
            ],
        };

        // Left section configuration with toolbar, filter, and table components
        const left = {
            height: screen.width < 500 ? 500 : 0, // Responsive height based on screen width
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Applying the current theme
                    elements: [
                        {
                            view: 'label',
                            label: _('Reporte de Casino'), // Localized label for the report
                            width: 300,
                        },
                    ],
                },
                FilterCasinoReport, // Including the filter component
                TableCasinoReport, // Including the table component
                toolbar, // Including the toolbar with pagination
            ],
        };

        webix.ui.fullScreen(); // Setting the UI to full screen mode

        // Returning the main layout configuration
        return {
            id: 'a5', // Unique identifier for the form
            type: 'clean',
            view: 'form',
            rows: [
                {
                    responsive: 'a5', // Responsive design for the form
                    type: 'wide',
                    cols: [left, right], // Combining left and right sections
                },
            ],
        };
    }
}

// FILE DOCUMENTED
